import { Box, Grid, Typography, Collapse, useMediaQuery } from "@mui/material";
import PageShell from "../shared/components/PageShell";
import { useTheme } from "@mui/material/styles";
import { useState, useRef, useCallback, useEffect } from "react";
import FeatureCard from "../shared/components/FeatureCard";
import SequencingReadsCard from "../shared/components/SequencingReadsCard";
import AssembledGenomeCard from "../shared/components/AssembledGenomeCard";
import cardImage from "../assets/Rectangle94.svg";
import cardImage2 from "../assets/Rectangle96.svg";

export default function Analyze() {
    const theme = useTheme();
    const is2KOrMore = useMediaQuery("(min-width:2048px)");

    const [colorSequencing, setcolorSequencing] = useState(is2KOrMore);
    const [colorAssembled, setcolorAssembled] = useState(false);

    const seqRef = useRef(null);
    const asmRef = useRef(null);

    useEffect(() => {
        if (is2KOrMore) {
            setcolorSequencing(true);
            setcolorAssembled(false);
        }
    }, [is2KOrMore]);

    const scrollToRef = useCallback((ref) => {
        if (!ref?.current) return;
        const NAV_HEIGHT = 90;
        const EXTRA = 16;
        const y =
            ref.current.getBoundingClientRect().top +
            window.scrollY -
            NAV_HEIGHT -
            EXTRA;

        window.scrollTo({ top: y, behavior: "smooth" });
    }, []);

    const handleOpenSequencing = () => {
        if (colorSequencing) {
            scrollToRef(seqRef);
        } else {
            setcolorSequencing(true);
            setcolorAssembled(false);
        }
    };

    const handleOpenAssembled = () => {
        if (colorAssembled) {
            scrollToRef(asmRef);
        } else {
            setcolorAssembled(true);
            setcolorSequencing(false);
        }
    };

    return (
        <Box>
            <PageShell>
                <Box sx={{ width: "100%" }}>
                    <Typography variant="h4">Analyze</Typography>
                </Box>
            </PageShell>

            <PageShell>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Grid
                        container
                        spacing={{ xs: 2, md: 0 }}
                        sx={{
                            width: "90%",
                            justifyContent: "center",
                        }}
                    >
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: { xs: "center", lg: "flex-start" },
                                    px: { xs: 2, sm: 2, md: 3 },
                                }}
                            >
                                <FeatureCard
                                    variant={colorSequencing ? "dark" : "light"}
                                    title="Identify resistance genes from sequencing reads"
                                    description="(only available for Acinetobacter baumannii, Klebsiella pneumoniae and Staphylococcus aureus isolates)"
                                    openInfo={handleOpenSequencing}
                                    image={cardImage}
                                />
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: { xs: "center", lg: "flex-end" },
                                    px: { xs: 2, sm: 2, md: 3 },
                                }}
                            >
                                <FeatureCard
                                    variant={colorAssembled ? "dark" : "light"}
                                    title="Identify resistance genes from an assembled genome"
                                    openInfo={handleOpenAssembled}
                                    image={cardImage2}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PageShell>

            <Collapse
                in={colorSequencing}
                timeout={420}
                easing={{
                    enter: theme.transitions.easing.easeOut,
                    exit: theme.transitions.easing.sharp,
                }}
                onEntered={() => scrollToRef(seqRef)}
            >
                <Box ref={seqRef}>
                    <PageShell>
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: "100%", sm: "90%", lg: "90%" },
                                    px: { xs: 2, sm: 2, md: 3 },
                                }}
                            >
                                <SequencingReadsCard
                                    onUploadMetadata={() => { }}
                                    onUploadR1={() => { }}
                                    onUploadR2={() => { }}
                                    onAnalyze={() => { }}
                                />
                            </Box>
                        </Box>
                    </PageShell>
                </Box>
            </Collapse>

            <Collapse
                in={colorAssembled}
                timeout={420}
                easing={{
                    enter: theme.transitions.easing.easeOut,
                    exit: theme.transitions.easing.sharp,
                }}
                onEntered={() => scrollToRef(asmRef)}
            >
                <Box ref={asmRef}>
                    <PageShell pb={"100px"}>
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: "100%", sm: "90%", lg: "90%" },
                                    px: { xs: 2, sm: 2, md: 3 },
                                }}
                            >
                                <AssembledGenomeCard
                                    onUploadMetadata={() => { }}
                                    onUploadR1={() => { }}
                                    onUploadR2={() => { }}
                                    onAnalyze={() => { }}
                                />
                            </Box>
                        </Box>
                    </PageShell>
                </Box>
            </Collapse>
        </Box>
    );
}